import CustomAxios from "..";

export const loginapi = async (formData) => {
  try {
    const response = await CustomAxios.post("/auth/signin/email",formData);
    return response.data;
  } catch (error) {
    console.error("Error fetching users count:", error);
    throw error;
  }
};
